import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { ArchiveInboundEmailMutation } from '@/gql/graphql';

const ARCHIVE_INBOUND_EMAIL_MUTATION = graphql(`
  mutation ArchiveInboundEmail($inboundEmailId: ID!) {
    archiveInboundEmail(inboundEmailId: $inboundEmailId) {
      id
      status
      assignedProject {
        id
        reference
      }
    }
  }
`);

const useArchiveInboundEmail = (
  options?: UseMutationOptions<
    ArchiveInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  return useMutation({
    mutationFn: ({ inboundEmailId }) => {
      return gqlClient.request(ARCHIVE_INBOUND_EMAIL_MUTATION, {
        inboundEmailId,
      });
    },
    ...options,
  });
};

export default useArchiveInboundEmail;
